import { render, staticRenderFns } from "./CompletedApplicationsTable.vue?vue&type=template&id=f18dbb90"
import script from "./CompletedApplicationsTable.vue?vue&type=script&lang=ts"
export * from "./CompletedApplicationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports